import { Tooltip } from 'antd';
import { SVGPureIcon } from '@/ui';
import ASRModal from './ASRModal';
import { observer } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import client from '@/store/client';
import globalStore from '@/store/global';

function Microphone(props) {
  const { disabled, isKnowledgeChat, onChange, scene="" } = props;

  const onClick = async () => {
    if (disabled) {
      return;
    }
    const input = await ASRModal.open();
    onChange?.(input);
  };

  return (
    <Tooltip trigger="hover" title="语音输入">
      <button
        className={[
          'rounded-full transition-colors duration-300 p-6px',
          !disabled ? globalStore.isDark ? 'hover:bg-[rgba(255,255,255,0.06)]':'hover:bg-black-6':'',
          // {
          //   'hover:bg-black-6': !disabled,
          // },
        ]}
        onClick={onClick}
      >
        <SVGPureIcon
          name={"microphone_v2"}
          className={[
            'size-20px text-primary',
            { 'text-opacity-30': disabled },
            { 'hidden-in-client': !client.supportMic },
          ]}
        />
      </button>
    </Tooltip>
  );
}

export default observer(Microphone);
